import { t } from "i18next";
import {
  Box,
  Flex,
  HStack,
  Image,
  Spacer,
  Stack,
  Text,
} from "@chakra-ui/react";
import { CrashType, Score } from "@keita/lanepatrol-sdk";
import {
  tRiskFactor,
  tScoreType,
  scoreCrashTypesIcons,
} from "../utils/score-utils";
import { getRiskColor, lightenColor } from "../../survey/utils/score-utils";

const entryMaxWidth = 150;

export const ViewScore = ({ score }: { score: Score | undefined | null }) => {
  return (
    <Flex direction="column" fontSize="sm">
      <Flex justifyContent="center" gap={5}>
        {Object.values(CrashType).map((scoreKey) => {
          const scoreEntry = score?.[scoreKey];
          const color = getRiskColor(scoreEntry?.riskFactor);
          const lightColor = lightenColor(color, 0.72);

          return (
            <Flex
              key={scoreKey}
              direction="column"
              width="100%"
              maxWidth={36}
              justifyContent="space-between"
            >
              <Image
                alignSelf="center"
                maxWidth={120}
                src={scoreCrashTypesIcons[scoreKey]}
                alt={tScoreType(scoreKey)}
              />

              <Text textAlign="center" mt={3} mb={3}>
                {tScoreType(scoreKey)}
              </Text>

              <Stack
                alignItems="center"
                padding={2}
                borderRadius="lg"
                backgroundColor={color}
                borderWidth="1px"
                borderColor="blackAlpha.200"
                boxShadow="sm"
              >
                <Box
                  width="full"
                  textAlign="center"
                  paddingX={2}
                  paddingY={1.5}
                  borderRadius="md"
                  backgroundColor={lightColor}
                  color="black"
                  fontSize="md"
                  fontWeight="bold"
                  lineHeight="short"
                >
                  {scoreEntry ? scoreEntry.value.toFixed(2) : "–"}
                </Box>
              </Stack>
            </Flex>
          );
        })}
      </Flex>

      <HStack mt={8} justifyContent="center">
        <Spacer />

        <GlobalScoreCard score={score} />

        <Spacer />
      </HStack>
    </Flex>
  );
};

const GlobalScoreCard = ({ score }: { score?: Score | null }) => {
  const color = getRiskColor(score?.global.riskFactor);
  const lightColor = lightenColor(color, 0.72);

  return (
    <Stack width="full" maxWidth={entryMaxWidth} alignItems="center" gap={3}>
      <Text textAlign="center" fontWeight="bold" lineHeight="short">
        {t("coding:global")}:
      </Text>

      <Stack
        width="full"
        gap={0}
        padding={2}
        borderRadius="lg"
        backgroundColor={color}
        borderWidth="1px"
        borderColor="blackAlpha.200"
        boxShadow="sm"
      >
        <Box
          textAlign="center"
          paddingX={2}
          paddingY={1.5}
          borderTopRadius="md"
          backgroundColor={lightColor}
          color="black"
          fontSize="md"
          fontWeight="bold"
        >
          {score ? score.global.value.toFixed(2) : "–"}
        </Box>

        <Box
          textAlign="center"
          paddingX={2}
          paddingY={1.5}
          borderBottomRadius="md"
          backgroundColor={lightColor}
          color="black"
          fontWeight="medium"
        >
          {score ? tRiskFactor(score.global.riskFactor) : "–"}
        </Box>
      </Stack>
    </Stack>
  );
};
